export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fCBc4AMP6lbBP.f8774833.woff2";